import script from "./Fyvideo.vue?vue&type=script&lang=ts&setup=true"
export * from "./Fyvideo.vue?vue&type=script&lang=ts&setup=true"

import "./Fyvideo.vue?vue&type=style&index=0&id=03d754ca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03d754ca"]])

export default __exports__